import ugr from '@/UGRoute';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
const ProtectedRoute = () => {
  const isLoggedIn = localStorage.getItem('fullName');

  if (isLoggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to={`/${ugr}/login`} />;
  }
};
export default ProtectedRoute;
